import { Box, Button, InputAdornment } from "@material-ui/core";
// import ContentFilter from "@material-ui/icons/FilterList";
import SearchIcon from '@material-ui/icons/Search';
import React, { useEffect } from 'react';
import { SelectInput, TextInput, useListContext } from 'react-admin';
import { Form } from 'react-final-form';
import { statusList, platformList } from './constant';

const EventFilter = props => {
  return props.context === "button" ? (
    <EventFilterButton {...props} />
  ) : (
      <EventFilterForm {...props} />
    );
};

const EventFilterButton = () => {
  const { showFilter } = useListContext();
  useEffect(() => {
    showFilter('main')
  }, [])
  return (
    <div />
  );
  {/* <Button
      size="small"
      color="primary"
      onClick={() => showFilter("main")}
      startIcon={<ContentFilter />}
    >
      Filter
    </Button> */}
};



const EventFilterForm = ({ open }) => {
  const {
    displayedFilters,
    filterValues,
    setFilters,
    hideFilter,
  } = useListContext();

  if (!displayedFilters.main) return null;

  const onSubmit = values => {
    if (Object.keys(values).length > 0) {
      setFilters(values);
    } else {
      hideFilter("main");
    }
  };

  const resetFilter = () => {
    setFilters({}, []);
  };

  return (
    <div>
      <Form onSubmit={onSubmit} initialValues={filterValues}>
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            {/* <Box mt={8} /> */}
            <Box display="flex" alignItems="flex-start" mb={1}>
              <Box component="span" mr={2}>
                {/* Full-text search filter. We don't use <SearchFilter> to force a large form input */}
                <TextInput
                  resettable
                  helperText={false}
                  source="uid"
                  label="Search by ID"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment>
                        <SearchIcon color="disabled" />
                      </InputAdornment>
                    )
                  }}
                  alwaysOn
                />
              </Box>
              <Box component="span" mr={2}>
                <TextInput
                  resettable
                  helperText={false}
                  source="slug"
                  label="Search by slug"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment>
                        <SearchIcon color="disabled" />
                      </InputAdornment>
                    )
                  }}
                  alwaysOn
                />
              </Box>
              <Box component="span" mr={2}>
                <TextInput
                  resettable
                  helperText={false}
                  source="title"
                  label="Search by title"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment>
                        <SearchIcon color="disabled" />
                      </InputAdornment>
                    )
                  }}
                  alwaysOn
                />
              </Box>
            </Box>
            <Box display="flex" alignItems="flex-start" mb={1}>
              <Box component="span" mr={2}>
                <SelectInput source="status" choices={statusList} alwaysOn allowEmpty />
              </Box>
              <Box component="span" mr={2}>
                <SelectInput source="language" choices={[
                  { id: 'TC', name: '中文' },
                  { id: 'EN', name: 'English' },
                  { id: 'SC', name: '簡体' },
                ]} alwaysOn allowEmpty />
              </Box>
              <Box component="span" mr={2}>
                <SelectInput source="platform_source" choices={platformList} alwaysOn allowEmpty />
              </Box>
              <Box component="span" mr={2} mt={2}>
                <Button variant="outlined" color="primary" type="submit">
                  Filter
                    </Button>
              </Box>
              {/* <Box component="span">
                <Button variant="outlined" onClick={resetFilter}>
                  Close
                    </Button>
              </Box> */}
            </Box>
          </form>
        )}
      </Form>
    </div>
  );
};

export default EventFilter;